/**
 * @generated SignedSource<<9816a423d4ed49f0c647e75a2e2e9239>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RulesFilterInputObject = {
  direction?: string | null | undefined;
  enabled?: boolean | null | undefined;
  expenseNatureId?: string | null | undefined;
  matchField?: string | null | undefined;
  matchKind?: string | null | undefined;
  needsReview?: boolean | null | undefined;
  search?: string | null | undefined;
  source?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  targetClassification?: string | null | undefined;
  targetType?: string | null | undefined;
  zeroMatches?: boolean | null | undefined;
};
export type rulesPage_Query$variables = {
  filter?: RulesFilterInputObject | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  sort?: string | null | undefined;
};
export type rulesPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
  }>;
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly pendingSuggestions: {
    readonly totalCount: number;
  };
  readonly rules: {
    readonly rules: ReadonlyArray<{
      readonly accounts: ReadonlyArray<{
        readonly id: string;
        readonly last4: string | null | undefined;
        readonly name: string;
        readonly nickname: string;
      }>;
      readonly caseSensitive: boolean;
      readonly destinationBankAccount: {
        readonly id: string;
        readonly last4: string | null | undefined;
        readonly name: string;
        readonly nickname: string;
      } | null | undefined;
      readonly direction: string;
      readonly enabled: boolean;
      readonly endDate: any | null | undefined;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly id: string;
      readonly matchField: string;
      readonly matchKind: string;
      readonly matchesCount: number;
      readonly needsReview: boolean;
      readonly ownedCount: number;
      readonly priority: number;
      readonly regex: string;
      readonly source: string;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly startDate: any | null | undefined;
      readonly targetClassification: string | null | undefined;
      readonly targetType: string;
    }>;
    readonly targetTypeCounts: ReadonlyArray<{
      readonly count: number;
      readonly targetType: string;
    }>;
    readonly totalCount: number;
  };
};
export type rulesPage_Query = {
  response: rulesPage_Query$data;
  variables: rulesPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nickname",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "last4",
    "storageKey": null
  }
],
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort"
      }
    ],
    "concreteType": "RulesPayload",
    "kind": "LinkedField",
    "name": "rules",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "RuleTargetTypeCount",
        "kind": "LinkedField",
        "name": "targetTypeCounts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rule",
        "kind": "LinkedField",
        "name": "rules",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "direction",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseSensitive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchField",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsReview",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetClassification",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ownedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BankAccount",
            "kind": "LinkedField",
            "name": "destinationBankAccount",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseNature",
            "kind": "LinkedField",
            "name": "expenseNature",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BankAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Stakeholder",
    "kind": "LinkedField",
    "name": "allStakeholders",
    "plural": true,
    "selections": (v8/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "bankAccounts",
    "plural": true,
    "selections": (v9/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ExpenseNature",
    "kind": "LinkedField",
    "name": "expenseNatures",
    "plural": true,
    "selections": (v8/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PendingSuggestionsPayload",
    "kind": "LinkedField",
    "name": "pendingSuggestions",
    "plural": false,
    "selections": [
      (v4/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_Query",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "rulesPage_Query",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "087aed2dcba73787df13960b2745c399",
    "id": null,
    "metadata": {},
    "name": "rulesPage_Query",
    "operationKind": "query",
    "text": "query rulesPage_Query(\n  $filter: RulesFilterInputObject\n  $sort: String\n  $limit: Int\n  $offset: Int\n) {\n  rules(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {\n    totalCount\n    targetTypeCounts {\n      targetType\n      count\n    }\n    rules {\n      id\n      regex\n      matchKind\n      direction\n      source\n      enabled\n      caseSensitive\n      priority\n      targetType\n      matchField\n      needsReview\n      targetClassification\n      matchesCount\n      ownedCount\n      startDate\n      endDate\n      stakeholder {\n        id\n        name\n      }\n      destinationBankAccount {\n        id\n        name\n        nickname\n        last4\n      }\n      expenseNature {\n        id\n        name\n      }\n      accounts {\n        id\n        name\n        nickname\n        last4\n      }\n    }\n  }\n  allStakeholders {\n    id\n    name\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n  }\n  expenseNatures {\n    id\n    name\n  }\n  pendingSuggestions {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a5862e1b61a2129ddf1a042629c423c";

export default node;
